import { AuthType } from '@notes/webintegrations-common'
import { userInfoCache } from '../caches'
import { GetUserInfoFactory } from './GetUserInfoFactory'

// Glue code to combine the auth factories and caches this app uses
export const createGetUserInfo = (authType: AuthType) => GetUserInfoFactory.create(authType, userInfoCache)
export const createGetUserInfoIfAuthenticated = () => GetUserInfoFactory.createIfAuthenticated(userInfoCache)
